export default __webpack_public_path__ + "static/media/twitter.d2c7fba7.png";